import { type Common } from '../../common.js';
import {
  type CreateValues,
  type EditResponse,
  type FindAllOptions,
  type TestEncounterPopulated,
  type UpdateValues,
} from '../../models/workflowTest/entity/encounter.js';

export default class API {
  common: Common;
  baseEndpoint = '/workflow-test/entity/encounter';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(options?: FindAllOptions): Promise<TestEncounterPopulated[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(encounterId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encounterId}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<EditResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.postJSON(url, values);
  }

  async clone(encounterId: string): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encounterId}/clone`);
    return await this.common.postJSON(url, {});
  }

  async update(encounterId: string, values: UpdateValues): Promise<EditResponse> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${encounterId}`);
    return await this.common.patchJSON(url, values);
  }
}
